<!--
首页数据统计
-->
<template>
  <div>
    <div class="flex-c-s" style="margin-bottom: 18px">
      <div class="title">数据统计</div>
      <el-date-picker
        v-model="elDate"
        type="daterange"
        align="right"
        size="small"
        unlink-panels
        :clearable="false"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="changeDate"
      >
      </el-date-picker>
    </div>
    <el-row :gutter="10">
      <el-col :lg="showClient ? 14 : 12" :md="24">
        <el-row :gutter="10">
          <el-col :sm="8" v-if="showClient">
            <div class="data-item">
              <div class="item-title">员工总数</div>
              <div class="flex-c-s">
                <span class="item-number">{{data.clientCount || 0}}</span>
                <img
                  src="@/assets/images/home_icon_khsl.png"
                  class="item-icon"
                />
              </div>
            </div>
          </el-col>
          <el-col :sm="showClient ? 8 : 12">
            <div class="data-item">
              <div class="item-title">工单数量</div>
              <div class="flex-c-s">
                <span class="item-number">{{data.sheetCount || 0}}</span>
                <img
                  src="@/assets/images/home_icon_gdsl.png"
                  class="item-icon"
                />
              </div>
            </div>
          </el-col>
          <el-col :sm="showClient ? 8 : 12">
            <div class="data-item">
              <div class="item-title">已回复</div>
              <div class="flex-c-s">
                <span class="item-number">{{data.replayCount || 0}}</span>
                <img
                  src="@/assets/images/home_icon_yhf.png"
                  class="item-icon"
                />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :lg="showClient ? 10 : 12" :md="24">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="data-item">
              <div class="item-title">处理中</div>
              <div class="flex-c-s">
                <span class="item-number">{{data.onCount || 0}}</span>
                <img
                  src="@/assets/images/home_icon_jdz.png"
                  class="item-icon"
                />
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="data-item">
              <div class="item-title">已完成</div>
              <div class="flex-c-s">
                <span class="item-number">{{data.completeCount || 0}}</span>
                <img
                  src="@/assets/images/home_icon_ywc.png"
                  class="item-icon"
                />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { formatTime } from '@/utils'

export default {
  components: {},
  data() {
    return {
      elDate: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },

      // 数据统计
      data: {}
    }
  },
  computed: {
    // 只有超管才显示客户总数
    showClient() {
      return this.$store.state.user.userType == '0'
    }
  },
  watch: {},
  mounted() {
    // 初始化时间
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    this.elDate = [start, end]

    this.getData(formatTime(start), formatTime(end))
  },
  methods: {
    // 获取数据统计
    getData(start, end) {
      this.$api.home
        .dataStatistics({
          startTime: start || this.elDate[0],
          endTime: end || this.elDate[1]
        })
        .then(({ data }) => {
          if (data.code == 200) {
            this.data = data.data
          }
        })
    },
    // 修改日期
    changeDate() {
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: bold;
  color: #333333 !important;
}
.data-item {
  flex: 1;
  height: 172px;
  padding: 0 20px 0 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: rgba(42, 97, 255, 0.06);
  border-radius: 6px;
  margin-right: 20px;
  margin-bottom: 10px;
  &:last-child {
    margin-right: 0;
  }
  .item-title {
    margin-bottom: 35px;
    font-size: 16px;
    color: #999999;
  }
  .item-number {
    font-size: 0.44rem;
    font-family: "Bebas Neue";
    color: #484a56;
  }
  .item-icon {
    width: 40px;
    height: 40px;
    margin-left: 10px;
    object-fit: contain;
  }
}
</style>
